module.exports = __webpack_public_path__ + "static/ale-2020-4ade54e133e91efe2e384197d4b28e63.mp4";